<div class="section-title">
    <div class="section-title__label">
        <bzg-icon [nameIcon]="'icon-ai-tools'" class="icon-ai-tools" [size]="32"></bzg-icon>
        <span>{{'AIFORPROCESSES.AI' | translate}}</span>
    </div>
</div>
<div class="card" [ngClass]="{'card--enabled': isWorkerEnabled}" *ngIf="aIWorkerConfiguration">
    <div class="left">
        <div class="icon-placeholder">
            <bzg-icon [nameIcon]="'icon-ai-worker'" [size]="32"></bzg-icon>
        </div>
        <div class="description">
            <div class="title">
                <bzg-icon *ngIf="hasOverride"
                    class="icon-ai-reset tooltip-container"
                    [nameIcon]="'icon-ai-reset'" 
                    [size]="14"  
                    [attr.data-tooltip]="'AIFORPROCESSES.RESET_DEVELOP' | translate"
                    (click)="onResetClick()">
                </bzg-icon>
                <span>{{'AIFORPROCESSES.WORKER' | translate}}</span>
                <span class="inheritance-indicator"
                    *ngIf="isWorkerInherited"
                    [attr.data-tooltip]="inheritanceTooltip">
                    {{'AIFORPROCESSES.INHERITED' | translate}}
                </span>
            </div>
            <div class="text">{{'AIFORPROCESSES.WORKER_DESCRIPTION' | translate}}</div>
        </div>
    </div>
    <div class="right">
        <bzg-switch 
            [ngModel]="aIWorkerConfiguration.enable" 
            (ngModelChange)="onWorkerEnableChange($event)">
        </bzg-switch>

        <div class="options">
            <span class="supervision-mode">{{'AIFORPROCESSES.SUPERVISION_MODE' | translate}}</span>
            <label>
                <input 
                    type="radio" 
                    name="worker-mode" 
                    [value]="WorkerType.Supervised"
                    [checked]="workerType === WorkerType.Supervised"
                    [disabled]="!isWorkerEnabled"
                    (change)="onWorkerModeChange(WorkerType.Supervised)"/> 
                    {{'AIFORPROCESSES.WORKER_MODE_SUPERVISED' | translate}}
            </label>
            <label>
                <input 
                    type="radio" 
                    name="worker-mode" 
                    [value]="WorkerType.Autonomous"
                    [checked]="workerType === WorkerType.Autonomous"
                    [disabled]="!isWorkerEnabled"
                    (change)="onWorkerModeChange(WorkerType.Autonomous)"/> 
                    {{'AIFORPROCESSES.WORKER_MODE_AUTONOMOUS' | translate}}
            </label>
            <label>
                <input 
                    type="radio" 
                    name="worker-mode" 
                    [value]="WorkerType.AutonomyRule"
                    [checked]="workerType === WorkerType.AutonomyRule"
                    [disabled]="true"/> 
                    {{'AIFORPROCESSES.WORKER_MODE_AUTONOMY_RULE' | translate}}
            </label>
        </div>

        <div class="reinforcement-learning" *ngIf="workerType === WorkerType.Supervised">
                <bzg-icon
                    class="reinforcement-learning-info"
                    [nameIcon]="'icon-info-rl'"
                    [size]="14"
                    [bzgTooltip]="'AIFORPROCESSES.REINFORCEMENT_LEARNING_TOOLTIP' | translate"
                    [bzgTooltipPosition]="'above'"
                    [bzgTooltipMaxWidth]="'350px'">
                </bzg-icon>
                <bzg-checkbox 
                    [id]="'enable-reinforcement-learning'" 
                    [ngModel]="aIWorkerConfiguration.enableReinforcementLearning"
                    [checked]="aIWorkerConfiguration.enableReinforcementLearning"
                    [disabled]="!isWorkerEnabled"
                    (ngModelChange)="onReinforcementLearningChange($event)">
                    {{ (aIWorkerConfiguration.enableReinforcementLearning ? 'AIFORPROCESSES.REINFORCEMENT_LEARNING_ENABLED' : 'AIFORPROCESSES.REINFORCEMENT_LEARNING_DISABLED') | translate }}
                </bzg-checkbox>
        </div>

        <div *ngIf="workerType === WorkerType.AutonomyRule">
            <span class="supervision-mode">{{'AIFORPROCESSES.WORKER_MODE_AUTONOMY_RULE' | translate}}: </span> 
            <span class="supervision-mode__rule">{{ruleName}}</span>
        </div>
    </div>
</div>